import * as amplitude from "@amplitude/analytics-browser";
import { format } from "date-fns";

export const trackEvents = (eventName, properties) => {
  const eventProperties = {
    Date: format(new Date(), "dd/MM/yyyy, HH:mm:ss"),
    ...properties,
  };

  amplitude?.track(eventName, eventProperties);
};

export { amplitude };

export const trackUserViaContactForm = ({
  firstName,
  lastName,
  email,
  phone,
}) => {
  const fullName = [firstName, lastName].filter(Boolean).join(" ");

  if (email) {
    const identifyObj = new amplitude.Identify();
    identifyObj.set("name", fullName || "unknown");
    identifyObj.set("email", email);
    identifyObj.set("phone", phone || "unknown");
    identifyObj.set("source", "contact_us_form");

    amplitude.setUserId(email);
    amplitude.identify(identifyObj);
  }

  trackEvents("contact_us_form_submitted", {
    name: fullName,
    email,
    phone,
    firstName,
    lastName,
  });
};
